// @flow

import { TREE } from 'hfty-order-supplies-dom/src/constants'

import _first from 'lodash/first'
import _map from 'lodash/map'

export default (state: Object): Object => _first(_map(state[TREE].orderTestsOperation))
